import { Injectable } from '@angular/core';

declare const mixpanel: any;

@Injectable()
export class TrackingService {


  constructor() { }

  fileSaved(): void {
    mixpanel.track('Save');
  }

  navigatedToSavedFiles(): void {
    mixpanel.track('Saved files');
  }

  fileExported(): void {
    mixpanel.track('Export');
  }

  fileImported(): void {
    mixpanel.track('Import');
  }

  dataSheetOpened(): void {
    mixpanel.track('Data sheet for product');
  }

  oringEstimated(unit: string): void {
    mixpanel.track('Estimate O-ring size ' + unit);
  }

  grooveEstimated(unit): void {
    mixpanel.track('Estimate Groove size ' + unit);
  }

  designValidated(recommendationType: string): void {
    mixpanel.track('Calculated after ' + recommendationType);
  }


  quoteRequested(): void {
    mixpanel.track('Request Sample');
  }

  chatOpened(): void {
    mixpanel.track('Chat');
  }

  emailOpened(): void {
    mixpanel.track('Email');
  }

  phoneClicked(): void {
    mixpanel.track('Phone');
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/tracking.service.ts